import type { CellCalibration } from '../lib/weightDebug'

// Per-cell calibration + enabled/disabled status, echoing the kodiak-proto load-cells
// view (cell · sign · offset · contribution · state) — read-only here (historical
// capture), in the panel's light palette: pine = enabled, coral = disabled.
export default function CalibrationBox({ cells }: { cells: CellCalibration[] }) {
  if (cells.length === 0) return null
  const fmt = (v: number | null, digits = 1) => (v == null ? '—' : v.toFixed(digits))
  return (
    <div className="rounded-lg bg-stone-50 border border-stone-100 px-3 py-2.5 space-y-1.5">
      <span className="font-mono text-[9px] tracking-[0.2em] uppercase text-stone-500">
        Calibration
      </span>
      <div className="font-mono text-[9px]">
        <div className="flex items-center gap-2 text-stone-400 border-b border-stone-200 pb-1">
          <span className="w-8">cell</span>
          <span className="w-6 text-center">sign</span>
          <span className="flex-1 text-right">slope</span>
          <span className="flex-1 text-right">offset</span>
          <span className="w-10 text-right">R²</span>
          <span className="w-14 text-right">state</span>
        </div>
        {cells.map(c => (
          <div key={c.ch} className={`flex items-center gap-2 py-0.5 ${c.enabled ? '' : 'opacity-60'}`}>
            <span className="w-8 text-stone-500">ch{c.ch}</span>
            <span
              className={`w-6 text-center rounded ${
                c.sign == null || c.sign === 0
                  ? 'text-stone-400'
                  : c.sign < 0
                    ? 'text-coral'
                    : 'text-pine'
              }`}
            >
              {c.sign == null ? '—' : c.sign < 0 ? '−' : c.sign === 0 ? '0' : '+'}
            </span>
            <span className="flex-1 text-right text-stone-600">{fmt(c.slope, 5)}</span>
            <span className="flex-1 text-right text-stone-600">{fmt(c.xIntercept, 1)}</span>
            <span className="w-10 text-right text-stone-600">{fmt(c.r2, 3)}</span>
            <span className={`w-14 text-right font-semibold ${c.enabled ? 'text-pine' : 'text-coral'}`}>
              {c.enabled ? 'enabled' : 'disabled'}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
